import { render, staticRenderFns } from "./UserInfoChange.vue?vue&type=template&id=688a078f"
import script from "./UserInfoChange.vue?vue&type=script&lang=js"
export * from "./UserInfoChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports